import {PaymentMethodDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_PAYMENT_METHOD';

export async function createPaymentMethod(
    userData: Record<string, string>,
    paymentMethod: Record<string, any>
) {
    try {
        const result = await PaymentMethodDao.createPaymentMethod(userData.userToken, paymentMethod);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
